import { useQuery } from '@tanstack/react-query';
import { authorizeAutodeskSSO } from 'api/services';
import { BrokenLinkIcon } from 'library/icons';
import { CircularProgress } from 'library/loaders';
import { IllustrationView } from 'modules/shared/features/illustration';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const constructAutodeskRedirectUrl = () => {
    return import.meta.env.VITE_APP_AUTH_REDIRECT_URL + '/autodesk-authorization';
};

const AutodeskIllustration = () => {
    return (
        <div className="flex items-center gap-5">
            <img className="h-10" src="/logos/logo.png" alt="progressCenter" />
            <BrokenLinkIcon />
            <img className="h-10" src="/plugins-images/autodesk.svg" alt="Microosft" />
        </div>
    );
};

const AutodeskAuthorizationPage = () => {
    const [searchParams] = useSearchParams();

    const code = searchParams.get('code');
    const state = searchParams.get('state');

    const redirectUri = constructAutodeskRedirectUrl();

    const { pluginId, url } = JSON.parse(decodeURIComponent(state));

    const autodeskAuthorizeQuery = useQuery(
        ['autodesk-authorize', code, redirectUri],
        () => authorizeAutodeskSSO({ code, redirectUri }),
        {
            retry: 0,
        }
    );

    if (autodeskAuthorizeQuery.isSuccess) {
        toast.success('Autodesk account linked successfully.');

        window.location.replace(`${url}/plugins/${pluginId}/autodesk`);
    }

    if (autodeskAuthorizeQuery.isLoading) {
        return (
            <section>
                <div className="fixed top-0 left-0 flex flex-col items-center justify-center h-screen w-full bg-card-color">
                    <div className="flex items-center justify-center w-14 h-14 rounded-lg text-primary ">
                        <CircularProgress size={32} />
                    </div>
                </div>
            </section>
        );
    }

    if (autodeskAuthorizeQuery.error) {
        return (
            <IllustrationView
                className="justify-center h-screen"
                illustration={<AutodeskIllustration />}
                title="Autodesk Authorization Failed"
                message={
                    <>
                        {/* We couldn’t connect to your Autodesk account. Please check your credentials or try again. */}
                        {(autodeskAuthorizeQuery.error as any).data.message}
                        <div className="mt-2">
                            <Link to={`${url}`} replace className="text-primary font-medium cursor-pointer">
                                Back to home
                            </Link>
                        </div>
                    </>
                }
            />
        );
    }
};

export default AutodeskAuthorizationPage;
